var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.hasValue && _vm.isPrivate)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"This data is set by you as Private and is not accessible to other Affiliates"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'lock'],"size":"sm"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }